import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { SuiDropdown, SuiDropdownOption } from '@splashthat/sui';

import { containerPaddingM } from 'common/styles/variables';

const baseClassName = 'FormLogoSizeDropdown';

const StyledSuiDropdown = styled(SuiDropdown)`
    margin-bottom: ${containerPaddingM};
`;

const FormLogoSizeDropdown = ({ imageSize, onChangeSize, logoSizes }) => (
    <StyledSuiDropdown
        className={`${baseClassName}`}
        fullWidth
        value={imageSize}
        onChange={(event, value) => onChangeSize(value)}
    >
        {Object.keys(logoSizes).map((size, index) => (
            <SuiDropdownOption key={index} value={size} displayValue={logoSizes[size].label} />
        ))}
    </StyledSuiDropdown>
);

FormLogoSizeDropdown.propTypes = {
    imageSize: PropTypes.string.isRequired,
    logoSizes: PropTypes.object.isRequired,
    onChangeSize: PropTypes.func.isRequired,
};

export default FormLogoSizeDropdown;
